import React, { useContext } from 'react';
import { Checkbox } from 'ui-components/components/checkbox';
import { FormattedMessage } from 'react-intl';
import { messages } from './messages';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { MarkBatchAsPrintedContext } from '../../context/mark-batch-as-printed';
import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import { useSellerFormattedDate } from '../../../../../hooks/use-datetime-formats';
import classnames from 'classnames';
import style from './style.module.less';

const PrintedDateWithMarkPrintedCheckbox = () => {
  const { printDate, isProcessing, hasError, onMarkAsPrintedChange } = useContext(MarkBatchAsPrintedContext);
  const formattedDate = useSellerFormattedDate(printDate);

  if (isProcessing) {
    return (
      <div className={style['info-row']}>
        <LoadingIndicator className={style['loading-indicator']} />
      </div>
    );
  }

  const labelDescriptorForPrintedDate = printDate ? (
    <FormattedMessage {...messages.batchPrintDateLabel} values={{ batchPrintDate: formattedDate }} />
  ) : (
    <FormattedMessage {...messages.markAsPrintedLabel} />
  );

  return (
    <div
      className={classnames(style['info-row'], {
        [style['has-error']]: hasError,
      })}
    >
      <Checkbox checked={printDate} label={labelDescriptorForPrintedDate} onChange={onMarkAsPrintedChange} />
      {hasError && (
        <InlineMessage className={style.inline} type={INLINE_MESSAGE_TYPES.error}>
          <FormattedMessage {...messages.inlineErrorForPrintDate} />
        </InlineMessage>
      )}
    </div>
  );
};

export { PrintedDateWithMarkPrintedCheckbox };
